import { validationTypes } from "../../../../../../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../../../data/formFieldType";

const initialState = {
  dtEfectiveDate: null,
  dtAmendmentDate: new Date(),
  dtTeminationDate: null,
  dtFirstBillDate: null,
  lInstallmentTypeID: null
}

export const addAmendmentsConfig = {
  name: "Add Department",
  initialState: initialState,
  section: [
    {
      sectionId: "Add Department",
      title: "Add Department",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12 pr-5",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "dtEfectiveDate",
          label: "Effective Date :",
          Field_Name: "Effective Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dtEfectiveDate",
          fieldSetting: {
            placeholder: "Effective Date",
            subTitle: " ",
            isDisable: true,
          },
          style: {
            containerCss: "col-lg-6 col-md-6 mb-2 po-to-datepicker po-input",
          },
        },
        {
          id: "dtAmendmentDate",
          label: "Amendment Date :",
          Field_Name: "Amendment Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dtAmendmentDate",
          fieldSetting: {
            placeholder: "Amendment Date",
            subTitle: " ",
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 mb-2 po-to-datepicker po-input",
          },
        },
        {
          id: "dtTeminationDate ",
          label: "Temination Date :",
          Field_Name: "Temination Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dtTeminationDate",
          fieldSetting: {
            placeholder: "Temination Date",
            subTitle: " ",
            isDisable: true,
          },
          style: {
            containerCss: "col-lg-6 col-md-6 mb-2 po-to-datepicker po-input",
          },
        },
        {
          id: "dtFirstBillDate",
          label: "First Bill Date :",
          Field_Name: "First Bill Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dtFirstBillDate",
          fieldSetting: {
            placeholder: "First Bill Date",
            subTitle: " ",
          },
          style: {
            containerCss: "col-lg-6 col-md-6 mb-2 po-to-datepicker po-input",
          },
        },
        {
          id: "lInstallmentTypeID",
          label: "Installment Type : ",
          Field_Name: "Installment Type",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lInstallmentTypeID",
          fieldSetting: {
            placeholder: "Installment Type",
            isDisable: true,
          },
          style: {
            containerCss: "col-md-6 mb-2",
          },
        },
      ]
    }
  ],
}